import React, { Component } from 'react';
class NotFound extends Component {
    
    render() { 
        return ( 
            <div>
                <h1 className="display-4">Page Not Found!</h1>
                <p>Sorry, the page you are looking for doesnot exist.</p>
            </div>
         );
    }
}
 
export default NotFound;